const buildQueryString = (data) => {
  return Object.keys(data)
    .map((key) => {
      return [key, data[key]].map(encodeURIComponent).join('=')
    })
    .join('&')
}

export const buildHotelListingUrlWithoutSelectedFlight = (props) => {
  const { queryString } = props
  const parsedQueryString = buildQueryString(queryString)

  return `/shop/search/?${parsedQueryString}`
}
